import { FaPrint, FaTrash, FaEye } from "react-icons/fa";
import { BsPencilSquare } from "react-icons/bs";

const InvoicesTable = ({
  currentInvoices,
  handlePrintInvoice,
  handleOpenDialog,
  handleDelete,
  showInvoice,
}) => {
  return (
    <div className="overflow-x-auto rounded-md shadow-sm border border-gray-200">
      <table className="min-w-[1000px] w-full text-sm md:text-base text-right rtl:text-right table-auto">
        <thead className="bg-gray-100 text-gray-700">
          <tr>
            {[
              "الكود",
              "التاريخ",
              "العميل",
              "التليفون",
              "العنوان",
              "المحافظة",
              "السكرتيرة",
              "عدد الأصناف",
              "تاريخ اليومية",
              "المندوب",
              "الحالة",
              "تاريخ التعديل",
              "الفاعل",
              "الطباعه",
              "التعديل",
              "الحذف",
              "عرض",
            ].map((title, idx) => (
              <th key={idx} className="px-2 py-2 whitespace-nowrap">
                {title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentInvoices.map((invoice) => (
            <tr
              className="hover:bg-gray-50 transition duration-200 border-b border-gray-100"
              key={invoice.id}
            >
              <td className="px-2 py-2">{invoice.invoiceCode}</td>
              <td className="px-2 py-2">{invoice.invoiceDate.split("T")[0]}</td>
              <td className="px-2 py-2">{invoice.customer}</td>
              <td className="px-2 py-2">{invoice.phone}</td>
              <td className="px-2 py-2 max-w-[120px] truncate">{invoice.address}</td>
              <td className="px-2 py-2">{invoice.governorate.name}</td>
              <td className="px-2 py-2">{invoice.createdBy || ""}</td>
              <td className="px-2 py-2 text-center">
                {invoice.invoiceCategories.length}
              </td>
              <td className="px-2 py-2">{invoice.dateCreated.split("T")[0]}</td>
              <td className="px-2 py-2">{invoice.representative?.fullName || "_"}</td>
              <td
                className={`px-2 py-2 font-semibold ${
                  invoice.status === "Paid"
                    ? "text-green-600"
                    : invoice.status === "Pending"
                    ? "text-orange-600"
                    : "text-red-600"
                }`}
              >
                {invoice.status}
              </td>
              <td className="px-2 py-2">{invoice.dateCreated.split("T")[0]}</td>
              <td className="px-2 py-2">{invoice.userName}</td>

              {/* Actions */}
              <td className="px-2 py-2 text-center">
                <button
                  className="p-1.5 md:p-2 rounded-full hover:bg-teal-100 transition"
                  onClick={() => handlePrintInvoice(invoice)}
                  title="Print Invoice"
                >
                  <FaPrint className="text-teal-600 text-base md:text-lg" />
                </button>
              </td>
              <td className="px-2 py-2 text-center">
                <button
                  className="p-1.5 md:p-2 rounded-full hover:bg-purple-100 transition"
                  onClick={() => handleOpenDialog(invoice)}
                  title="Edit Invoice"
                >
                  <BsPencilSquare className="text-purple-600 text-base md:text-lg" />
                </button>
              </td>
              <td className="px-2 py-2 text-center">
                <button
                  className="p-1.5 md:p-2 rounded-full hover:bg-red-100 transition"
                  onClick={() => handleDelete(invoice)}
                  title="Delete Invoice"
                >
                  <FaTrash className="text-red-600 text-base md:text-lg" />
                </button>
              </td>
              <td className="px-2 py-2 text-center">
                <button
                  className="p-1.5 md:p-2 rounded-full hover:bg-blue-100 transition"
                  onClick={() => showInvoice(invoice)}
                  title="View Invoice"
                >
                  <FaEye className="text-blue-600 text-base md:text-lg" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InvoicesTable;
